import { useState, useEffect } from 'react'
import SparkMD5 from 'spark-md5'

const useUserType = (userType?: string | null): string => {
  const t = userType?.toLowerCase()
  if (t === 'general') return 'Member'
  if (t === 'producer') return 'Producer'
  if (t === 'market') return 'Market'
  return userType || 'Member'
}

export async function uploadToS3(file) {
  if (!file) {
    alert("Please select a file.");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch("/api/upload-url", {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Failed to upload file");
  }

  const { fileUrl } = await response.json();

  return fileUrl;
}

export default useUserType
